export const GET_BATTLES = "GET_BATTLES";
export const GET_TODAYS_BATTLES = "GET_TODAYS_BATTLES";
export const SUBMIT_VOTE = "SUBMIT_VOTE";
export const GET_HEROES = "GET_HEROES";

export const GET_ERRORS = "GET_ERRORS";
export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const GET_PROFILE = "GET_PROFILE";
export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_NOT_FOUND = "PROFILE_NOT_FOUND";
export const CLEAR_CURRENT_PROFILE = "CLEAR_CURRENT_PROFILE";
export const GET_PROFILES = "GET_PROFILES";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

export const ADD_SUGGESTION = "ADD_SUGGESTION";
export const GET_SUGGESTIONS = "GET_SUGGESTIONS";
export const VOTE_ON_SUGGESTION = "VOTE_ON_SUGGESTION";

export const SEND_MESSAGE = "SEND_MESSAGE";
export const GET_MESSAGES = "GET_MESSAGES";
export const ADD_MESSAGE = "ADD_MESSAGE";
